import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { RevenuePreset } from "types/revenue";

export const expenseApi = {
  findAll: (params: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/expense",
      params,
    }),

  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/expense",
      data,
      method: "post",
    }),

  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/expense/${id}`,
      method: "patch",
      data,
    }),

  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/expense/${id}`,
      method: "delete",
    }),

  importExcel: (file: File): AxiosPromise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    return request({
      url: "/v1/admin/expense/import",
      method: "post",
      data: formData,
      timeout: 120000,
    });
  },

  summary: (preset: RevenuePreset): AxiosPromise<any> =>
    request({
      url: "/v1/admin/expense/summary",
      params: { preset },
    }),

  monthlyChart: (year: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/expense/chart/monthly",
      params: { year },
    }),

  categoryChart: (year: number): AxiosPromise<any> =>
    request({
      url: "/v1/admin/expense/chart/category",
      params: { year },
    }),
};
